import { render, staticRenderFns } from "./EmailTab.vue?vue&type=template&id=85162d8e"
import script from "./EmailTab.vue?vue&type=script&lang=ts"
export * from "./EmailTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports